import React, { useState } from "react";
import Modal from "../Modal/Modal";
import Video from "./Video";
import { VideoEmbedType } from "../types/VideoEmbed";
import VideoPreview from "./VideoPreview";
import { CtaButton } from "../Cta/cta-button";

const VideoEmbed: React.FC<VideoEmbedType> = ({
  wistiaId,
  backgroundImage,
  backgroundImageAltText,
  isPlaying,
  previewEnabled,
  ctaButtonProps,
  setIsPlaying,
  triggerAnalytics,
}) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  return (
    <>
      {previewEnabled ? (
        <VideoPreview
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          backgroundImage={backgroundImage}
          backgroundImageAltText={backgroundImageAltText}
          triggerAnalytics={triggerAnalytics}
        />
      ) : (
        ctaButtonProps &&
        ctaButtonProps?.copy &&
        ctaButtonProps?.variant && (
          <div className="flex">
            <CtaButton
              {...ctaButtonProps}
              onClick={() => {
                setIsModalOpen(true);
                if (triggerAnalytics) {
                  triggerAnalytics();
                }
              }}
              noLink
            />
          </div>
        )
      )}
      <Modal
        isOpen={isModalOpen}
        toggle={setIsModalOpen}
        setIsPlaying={setIsPlaying}
        customContentClass="dialog--embed--video"
      >
        <Video isPlaying={isPlaying} wistiaId={wistiaId} />
      </Modal>
    </>
  );
};

export default VideoEmbed;
